import { Col, Row } from "react-bootstrap";
import type { ReactNode } from "react";
import type { EpicLeaderboardStats } from "../../types/epicLeaderboard";
import BossChips from "./BossChips";
import EpicRunNote from "./EpicRunNote";
import { formatDate } from "./format";
import "./epicLeaderboard.css";

type Props = {
  stats: EpicLeaderboardStats;
};

const Tile = ({
  label,
  value,
  sub,
  children
}: {
  label: string;
  value: string;
  sub?: string;
  children?: ReactNode;
}) => (
  <div className="epic-lb-card">
    <div className="epic-lb-card-title">{label}</div>
    <div className="epic-lb-tile-value">{value}</div>
    {sub && <div className="epic-lb-muted">{sub}</div>}
    {children}
  </div>
);

const EpicStatTiles = ({ stats }: Props) => (
  <>
    <Row className="g-3 mb-3">
      <Col xs={6} md={3}>
        <Tile label="Runs" value={stats.totalRuns.toLocaleString()} />
      </Col>
      <Col xs={6} md={3}>
        <Tile label="Players" value={stats.uniquePlayers.toLocaleString()} />
      </Col>
      <Col xs={6} md={3}>
        <Tile label="Average" value={stats.average ?? "-"} />
      </Col>
      <Col xs={6} md={3}>
        <Tile label="Median" value={stats.median ?? "-"} />
      </Col>
    </Row>
    <Row className="g-3 mb-4">
      <Col xs={12} md={8}>
        <Tile
          label="Record"
          value={stats.record ? stats.record.time : "-"}
          sub={
            stats.record
              ? `${stats.record.players.join(", ")} - ${formatDate(
                  stats.record.runDate
                )}`
              : undefined
          }
        >
          {stats.record && (
            <>
              <BossChips bosses={stats.record.bosses} />
              <EpicRunNote
                runId={stats.record.runId}
                note={stats.record.note}
              />
            </>
          )}
        </Tile>
      </Col>
      <Col xs={12} md={4}>
        <Tile
          label="Most active"
          value={stats.mostActive ? stats.mostActive.player : "-"}
          sub={
            stats.mostActive
              ? `${stats.mostActive.runs.toLocaleString()} runs`
              : undefined
          }
        />
      </Col>
    </Row>
  </>
);

export default EpicStatTiles;
